import { Box, Icon, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileTypeEnum } from "../../../_common/enum/fileType.enum";
import { UserTypeEnum } from "../../../_common/enum/userType.enum";
import { IFilteringViewModel } from "../../../_common/interface/table/iTableFilter.interface";
import { StandardList } from "../../../_components/list/standardList.component";
import { StandardListItem } from "../../../_components/list/standardListItem.component";
import { toastr } from "../../../_components/toastr/toastr";
import { SECONDARY_COLOR, SUCCESS_COLOR, WARNING_COLOR } from "../../../_const/color.const";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { fileUploadService } from "../../../_services/fileUpload.service";
import { FileStatusIcon } from "./ticket-uploadsFileStatus";

export function TicketFileList(params: { fileType: FileTypeEnum, onSave?: () => void, refreshCounter: number }) {

    const resetData = () => ({});


    const { id } = useParams<{ id: string }>();
    const { fileType } = params;
    const [data, setData] = useState<any>(resetData);
    const [isLoading, setIsLoading] = useState(false);
    const [ticketFiles, setTicketFiles] = useState<any[]>([]);
    const [filter, setFilter] = useState<IFilteringViewModel>({
        ticketId: fileType === FileTypeEnum.Ticket ? id : null,
        caseId: fileType === FileTypeEnum.Case ? id : null,
    });


    useEffect(() => {
        if (id != null) fetchData();
        else setData(resetData);
    }, [id]);

    useEffect(() => {
        if (params.refreshCounter > 0)
            fetchData();
    }, [params.refreshCounter]);


    function fetchData() {
        setIsLoading(true);

        var _filter = { ...filter, ticketId: id };

        return fileUploadService.getAll(fileType, _filter)
            .then(
                data => {
                    setTicketFiles(data.items);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }


    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);

        console.log("disable", id);

        return fileUploadService
            .disable(id)
            .then(
                () => {
                    toastr.success("File deleted successfully");
                    fetchData();

                    if (fileType === FileTypeEnum.Case)
                        params.onSave?.();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }


    function download(id: string) {
        console.log("download", id);
        return fileUploadService.download(id);
    }

    const [searchTerm, setSearchTerm] = useState("");
    const filteredFiles = ticketFiles.filter(item =>
        item.fileName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    function getBackGroundColour(userTypeId: any) {
        if (userTypeId === UserTypeEnum.Agent)
            return { primary: SUCCESS_COLOR, hover: "green" };

        if (userTypeId === UserTypeEnum.Client)
            return { primary: SECONDARY_COLOR, hover: WARNING_COLOR };

    }

    return (
        <> 
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6"></Typography>

                    <Box display="flex" alignItems="center" flexGrow={1}>
                        <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search files..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            fullWidth
                        />
                    </Box>
            </Box>

        <StandardList isLoading={isLoading}>
            {(!isLoading && !!ticketFiles.length) && filteredFiles.map((item: any, index: number) => (
                <StandardListItem
                    sx={{
                        backgroundColor: getBackGroundColour(item.userTypeId)?.primary, //Red background for public Actions
                        '&:hover': {
                            backgroundColor: getBackGroundColour(item.userTypeId)?.hover, //Red background for public Actions
                        },
                    }}
                    primary={item.fileName}
                    secondary={
                            <FileStatusIcon stateId={item.fileUploadStateId} />
                    }
                    buttons={[
                        { icon: "download", onClick: () => download(item.fileUploadId), variant: "primary" },
                        { icon: "delete", onClick: () => disable(item.fileUploadId), variant: "error" },
                    ]}
                    key={item.id}

                />

            ))}

            </StandardList>

        </>
    );

}
